/**
 * WHAT A SIDE OF AN OPPOSED ROLL STANDS ON.
 *
 * A character opposes with its characteristic; a statblock (a target with
 * no sheet) with the plain axis that characteristic maps to, when it has
 * one. The same answer for the side rolling and the side opposing, so the
 * action sheet asks it once per side. Pure, and zero React dependency.
 */
import { plainAxisFor, type OpposedSide } from './opposedTests';
import type { Character, CharacteristicId } from './character/types';
import type { Target } from '../types';

/** One side's sheet or statblock. */
export interface Footing {
  character?: Character | null;
  target?: Target | null;
}

/** The side this footing opposes with, or null when it has none for this characteristic. */
export function opposedSide(footing: Footing | null | undefined, charId: CharacteristicId): OpposedSide | null {
  if (!footing) return null;
  if (footing.character) return { kind: 'characteristic', character: footing.character, charId };
  if (!footing.target) return null;
  const axis = plainAxisFor(charId);
  return axis ? { kind: 'plain', target: footing.target, testId: axis } : null;
}

/** Nothing opposes from beyond the grave: a statblock carrying the Killed condition. */
export function isDeadFooting(footing: Footing | null | undefined): boolean {
  return (footing?.target?.conditions ?? []).some((c) => c === 'K');
}
